<template>
  <van-popup
    v-model="visible"
    :style="{ height: '50%' }"
    :position="'bottom'"
    :close-on-click-overlay="true"
    :round="true"
    get-container="body"
    @close="handleClose"
  >
    <div class="shop-list-popup">
      <!-- 拖拽手柄 -->
      <div class="popup-handle"></div>
      
      <!-- 标题 -->
      <div class="popup-header">
        <div class="header-title">该位置有 {{ shopList.length }} 个点位</div>
      </div>
      
      <!-- 点位列表 -->
      <div class="popup-content">
        <div 
          class="shop-item"
          v-for="(shop, index) in shopList"
          :key="`shop-${shop.id || index}`"
          @click="handleShopClick(shop)"
        >
          <div class="shop-icon">
            <img :src="shop.shop_cover || perIcon" alt="" @error="handleImageError" />
          </div>
          <div class="shop-content">
            <div class="shop-name">{{ shop.name || '未知店铺' }}</div>
            <div class="shop-desc" v-if="shop.address">{{ shop.address }}</div>
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
let perIcon = 'https://lbs-nfncb.nfncb.cn/gzmap/img/per.png'

export default {
  name: 'ShopListPopup',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    shopList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      perIcon: perIcon
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('input', false)
    },
    handleShopClick(shop) {
      this.$emit('shop-click', shop)
      this.handleClose()
    },
    handleImageError(event) {
      event.target.src = this.perIcon
    }
  }
}
</script>

<style scoped>
.shop-list-popup {
  height: 100%;
  width: 10rem;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 0 20px;
}

.popup-handle {
  width: 60px;
  height: 6px;
  background-color: #e0e0e0;
  border-radius: 3px;
  margin: 12px auto;
}

.popup-header {
  padding: 20px 0;
  border-bottom: 1px solid #f0f0f0;
}

.header-title {
  font-size: 32px;
  font-weight: 500;
  color: #333;
  text-align: center;
}

.popup-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px 0;
}

.shop-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px 0;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.2s;
}

.shop-item:active {
  background-color: #f5f5f5;
}

.shop-item:last-child {
  border-bottom: none;
}

.shop-icon {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.shop-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.shop-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.shop-name {
  font-size: 30px;
  font-weight: 500;
  color: #333;
  line-height: 1.4;
}

.shop-desc {
  font-size: 24px;
  color: #999;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>

